import React, { useEffect, useState } from "react"

import { ChatDownIcon, PowerfulMessage } from "@shared/components"
import { useMessagesRef, useVodMessages } from "@shared/hooks"
import { Message } from "@shared/hooks/useMessages"
import { messageService } from "@shared/services"

import { useSelectedVod, useVodPlayer } from "vod/contexts"

const OFFSET = 8 + 4 + 5 - 329
const { toMessage } = messageService

interface Props {
  isContinueMessage: boolean
}

export default function Messages({ isContinueMessage }: Props) {
  const player = useVodPlayer()
  const selectedVod = useSelectedVod()
  const { messageBucket } = useVodMessages({ vod: selectedVod })

  const [messages, setMessages] = useState<Message[]>([])
  const [currentTime, setCurrentTime] = useState(0)

  const { messagesRef, handleScroll: scrollMessages } = useMessagesRef({
    scrollOffset: OFFSET,
    messages,
  })

  useEffect(() => {
    if (!player) return

    const evtSeeking = () => {
      const prevMessages: Message[] = []
      Object.keys(messageBucket).forEach((key) => {
        const _key = Number(key)
        if (_key < 0 || _key >= Number(player.currentTime())) return

        prevMessages.push(...messageBucket[_key])
      })

      setMessages(prevMessages)
    }

    const evtTimeUpdate = () => {
      setCurrentTime(Math.floor(player.currentTime()))
    }

    player.on("timeupdate", evtTimeUpdate)
    player.on("seeking", evtSeeking)

    return () => {
      player.off("timeupdate", evtTimeUpdate)
      player.off("seeking", evtSeeking)
    }
  }, [player, messageBucket])

  useEffect(() => {
    if (
      !currentTime ||
      !messageBucket ||
      !messageBucket.hasOwnProperty(currentTime)
    )
      return

    setMessages((prevMessages: Message[]) =>
      Array.from(new Set(prevMessages.concat(messageBucket[currentTime]))),
    )
  }, [currentTime, messageBucket])

  useEffect(() => {
    if (isContinueMessage) return

    setMessages([])
  }, [isContinueMessage, selectedVod])

  return (
    <div className="chatB">
      <div className="inner" ref={messagesRef}>
        {messages.length > 0 ? (
          messages.map((message: Message) => {
            return (
              <PowerfulMessage
                key={message.key}
                scrollMessages={scrollMessages}
                message={toMessage(message)}
              />
            )
          })
        ) : (
          <p>채팅 내용이 없습니다</p>
        )}

        <ChatDownIcon messagesRef={messagesRef} />
      </div>
    </div>
  )
}
